export default {
  data() {//Declaracao de variaveis

    return {
      //lista de campos que não precisam ser preenchidos
      desObrigaGeral: [
        "inss",
        "dataValidadeInss",
        "dataSolicitacao",
        "fgts",
        "dataValidadeFgts",
        "sefaz",
        "dataValidadeSefaz",
        "sefazba",
        "dataValidadeSefazba",
        "sefazFornecedor",
        "dataValidadeSefazFornecedor",
        "sefazpms",
        "dataValidadeSefazpms",
        "trabalhista",
        "dataValidadeTrabalhista",
        "statusSolicitacao",
        "arquivo",
        "tbFornecedores",
        "motivoNaoHabilitacao",
        "familiasSimpas",
        "nomSocial",
        "sitFornecedor",
        "nomAnalista",
        "codSecretaria",
        "numUnidade",
        "motivoExclusao",
        "fornecedorSimpas",
        "senha",
        "endEmail2",
        "endEmail3",
        "situacaoSolicitacao",
        "nomFantasia",
        "endComplemento",
        "uploadDeclaracao",
        "numSolicitacao",
        "numFax",
        "indRecEmails",
        "arquivoUpload",
        "dataContratoSocial",
        "endCepEstrangeiro",
        "nomUFEstrangeira",
        "nomCadastrador",
        "cpfCadastrador",
        "emailCadastrador",
        "telCadastrador",
        "usuarioCadastradorId",
        "usuarioCadastrador",
        "arquivoUploadSituacao",
        "motivoArquivoUploadRejeitado",
        "dtArquivoUploadRejeicao",
        "tipoSolicitacao",
        "motivoSolicitacaoRejeitado",
        "dataSolicitacaoRejeitado",
        "listaDocsQualificacaoTecnica",
        "isFuncionarioPublico",
        "vwSrhCargaFuncionario",
        "arquivoFiplan",
        "numDocumentoSEI",
        "linkProcedimentoSEI",
        "numProcedimentoSEI",
        "linkDocumentoSEI",
        "dataCriacao",
        "modeloUltimaSolicitacaoSimpas",
        "ultimaSolicitacaoSimpas",
        "motivoDeIndeferimento",
        "idMotivoIndeferimentoArquivo",
        "idMotivoIndeferimentoArquivo2",
        "idMotivoIndeferimentoArquivo3",
        "idMotivoIndeferimentoArquivo02",
        "idMotivoIndeferimentoArquivo02_2",
        "idMotivoIndeferimentoArquivo02_3",
        "motivoIndeferimentoStr",
        "documentosSolicitacao",
        "documentoRg",
        "rgRepresentanteLegal",
        "razaoSocialRepresentanteLegal",
        "cnpjRepresentanteLegal",
        "enderecoRepresentanteLegal",
        "bairroRepresentanteLegal",
        "cidadeRepresentanteLegal",
        "estadoRepresentanteLegal",
        "cepRepresentanteLegal",
        "celularRepresentanteLegal",
        "telRepresentanteLegal",
        "emailRepresentanteLegal",
        "unidadeSolicitante",
        "representanteLegal",
        "dtVencimento",
        "numDocumento",
        "termoConcordanciaVeracidade",
        "anexoRelatorioInscricaoRegistro",
        "docRelatorioRegistroCadastral",
        "dataAnalise",
        "flagSociedadeAnonima",
        "motivoAlteracaoCertificado",
        "dataCancelamentoPorPrazo",
        "solicitacaoVencida",
        "idUsuarioValidTermo",
        "flagCriacaoProcedimentoSEI",
        "usuarioAnalistaDuplaConferencia",
        "usuarioAnalistaDuplaConferenciaId",
        "possuiCertificadoDigital",
        "passivoCirculante",
        "ativoCirculante"
      ],
    }

  },
  methods: {//Declaracao de todos os metodos

    validaModel(proximaAba) {
      if (this.$verificaPerfilHabilitador && this.$verificaPerfilHabilitador()) {
        return true;
      }
      //verificar se as informações estão cadastradas de forma correta
      switch (proximaAba) {
        case "tab-dados":
          var ret = this.validModelDadosBasicos();

          return ret;

        case "tab-hab-juridica":
          var ret = this.validModelHabJuridica();

          return ret
        case "tab-familia":
          var ret = this.validModelFamilia();

          return ret;
        case "tab-qualificacaoTecnica":
          var ret = this.validModelQualificacaoTecnica();

          return ret;
        case "tab-regularidadeFiscal":
          var retorno = true;
          var ret = this.validModelRegularidadeFiscal();
          if (!this.$verificaPerfilHabilitador()) {
            retorno = this.verificaPreenchimentoRegFiscal(retorno);
          }

          return ret && retorno;
        case "tab-qualificacao":
          var ret = this.validModelQualificacao();

          return ret;
        case "tab-formulariosDeclaracoes":
          var ret = this.validModelFormulariosDeclaracoes();

          return ret;
        default:
          var ret = this.validModelDadosBasicos();

          return ret;
      }
    },

    validModelDadosBasicos() {
      //valida dados baisicos do cadastro
      let desObriga = [];
    
      if (this.model.tipFornecedor === "F") {
        desObriga.push("finalidadeEmpresa");
      }

      // flagEstrangeiro é um tipo string
      if (this.model.flagEstrangeiro === '0') {
        desObriga.push("endCepEstrangeiro");
        desObriga.push("nomCidadeEstrangeira");
        desObriga.push("nomUFEstrangeira");
        desObriga.push("endCidade");
      } else {
        desObriga.push("endCep");
        desObriga.push("endCidade");
        //AJUSTES chamado #106451"
        desObriga.push("endLogradouro");
        desObriga.push("endNumero");
        desObriga.push("endBairro");
        desObriga.push("nomCidadeEstrangeira");
        //Fim Ajustes chamado #106451"

        desObriga.push("endCepEstrangeiro");
        desObriga.push("codUf");

      }
      desObriga.push("familiaSolicitacao");
      desObriga.push("fornecedoresHabilitacaoJuridica");
      desObriga.push("concordataFalencia");
      desObriga.push("balancoFinanceiro");
      desObriga.push("qualificacaoTecnica");

      desObriga.push("usuarioAnalistaDuplaConferencia");
      desObriga.push("usuarioAnalistaId");
      desObriga.push("usuarioAnalista");
      desObriga.push("usuarioAnalistaDuplaConferenciaId");

      return this._validaModel(desObriga);
    },

    validModelHabJuridica() {
  
      //valida dados basicos do cadastro
      if (!this.validModelDadosBasicos()) {
        return false
      }
      return true;
    },

    validModelFamilia() {
      //valida tambem a habilitacao juridica
      if (this.model.tipFornecedor === "F") {
        if (!this.validModelDadosBasicos()) {
          return false
        }
      } else if (!this.validModelHabJuridica()) {
        return false
      } else {

        if (!this.model.fornecedoresHabilitacaoJuridica || !this.model.fornecedoresHabilitacaoJuridica.length) {
          this.setErro("Cadastre pelo menos um Dirigente ou um Sócio.", "tab-hab-juridica");
          return false;
        }//Caso haja algum sócio/dirigente com documento anexo inválido.
        else if (
          this.model.fornecedoresHabilitacaoJuridica &&
          this.model.fornecedoresHabilitacaoJuridica.length
        ) {

         let docInvalido = this.model.fornecedoresHabilitacaoJuridica.filter(item => 
            item.arquivoUpload === "Não Encontrado");        

          if (docInvalido.length > 0){
            this.setErro("Anexe o documento do Dirigente/Sócio: " + (docInvalido[0].nome), "tab-hab-juridica")
            return false;
          }

        }
         else {
          let percentTotal = 0;
          this.model.fornecedoresHabilitacaoJuridica.filter(item => {
            if (item.tipoCadastro === "S") {
              percentTotal += item.percentual;
            }
          });

          // chama método que verifica se o percentual total de socios é menor que 100%
          return this.verificaPercentTotal(percentTotal);
        }
        return this.verificaAnexosHabilitacaoJuridica();
      }
      return true;
    },

    // chama método que verifica se o percentual total de socios é menor que 100%
    verificaPercentTotal(percentTotal){
      if (percentTotal && parseFloat(percentTotal.toFixed(2)) < 100) {
        this.setErro(this.$t('messages.validacao.percentualMenorQue100'), "tab-hab-juridica");
        return false; // percentual total é menor que 100%
      } else {
        return true; // percentual total é igual a 100%
      }
    },

    //verifica anexos dos documentos de habilitação jurídica
    verificaAnexosHabilitacaoJuridica(){
      let documentos = this.model.documentosSolicitacao.filter(doc => {
        var docInfo = this.model.listaDocFornecSolicitacao
          ? this.model.listaDocFornecSolicitacao.find(x => x.codDocumento === doc.codDocumento)
          : null;
        var obrigatorio = docInfo ? docInfo.indObrigatoriedade === "O" : true;
        return doc.numHabilitacao === "2" && 
          ((doc.arquivoUpload == null && obrigatorio) || 
           (doc.arquivoUpload != null && doc.arquivoUpload === "Não Encontrado"));
      });
      if(documentos.length > 0){
        this.setErro('Anexo inválido',"tab-hab-juridica");
        this.hasErroDocHabilitacao = true;
        return false;
      }else{
        this.hasErroDocHabilitacao = false;
        return true;
      }
    },

    validModelQualificacaoTecnica() {
      var familiasSemAnexo = [];
      //valida tambem a familia
      if (!this.validModelFamilia()) {
        return false
      } else {
        if (this.model.familiaSolicitacao.length > 0) { //Se possuir familias solicitadas
          if(this.model.tipoCertificado !== 3 ){ // Se não for tipo Candidato/Credenciamento
            familiasSemAnexo = this.verificaFamiliaSemAnexo()
            if(familiasSemAnexo.length > 0){
            
              this.setErro("Cadastre o Atestado de Capacidade Técnica das famílias <br><strong>" + familiasSemAnexo.join('<br>') + "</strong>", "tab-familia");
              this.hasErrorFamilia = true;
              return false;
            }else{
              this.hasErrorFamilia = false;
              return true;
            }
          }
          this.hasErrorFamilia = false;
          return true;
        } else {
          //console.log('Familia vazia..');
          this.setErro(this.$t('messages.validacao.familiaVazia'), "tab-familia");
          return false
        }
      }
    },

    validModelRegularidadeFiscal() {
      
      //valida tambem a qualificacao tecnica
      if (!this.validModelQualificacaoTecnica()) {
        return false
      } else {
        return this.verificaFamiliaQualificacaoTecnica();
      }

    },

    verificaFamiliaQualificacaoTecnica(){
      var retorno = true;
      const qualificacoesOriginais = this.fornecedorQualificacaoTecnicaVm &&
        Array.isArray(this.fornecedorQualificacaoTecnicaVm.lista) &&
        this.fornecedorQualificacaoTecnicaVm.lista.length
        ? this.fornecedorQualificacaoTecnicaVm.lista
        : this.model.qualificacaoTecnica;
      const qualificacoes = (Array.isArray(qualificacoesOriginais)
        ? qualificacoesOriginais
        : []).map(item => item.qualificacaoTecnica || item);
      const mesmoCodigo = (primeiro, segundo) =>
        String(primeiro).trim() === String(segundo).trim();

        const ehSalvadorBA = () => {
        return this.model.codUf === "BA" && 
              this.model.endCidade && 
              this.model.endCidade.toUpperCase().trim() === "SALVADOR";
          };

      var listaDocumentos = this.listaDocsQualificacaoTecnica &&
        Array.isArray(this.listaDocsQualificacaoTecnica.lista)
        ? this.listaDocsQualificacaoTecnica.lista
        : [];
      var exigiveis = listaDocumentos.filter(x => {
        if (Number(x.codDocumento) === 180 && !ehSalvadorBA()) {
          return false; // Ignora documento 180 se não for Salvador/BA
        }
        return x.exigido === "S" && x.codDocumento !== 109 && x.codDocumento !== 166;
      });

      var elegiveis = this.listaDocsQualificacaoTecnica.lista.filter(x => x.elegivel === "S");
      var arrayErrosExigiveisFamilia = [];
      var arrayErrosElegiveisFamilia = [];

      if(this.model.flagEstrangeiro === '1') return true;
      //Pecorrendo as Familias Cadastradas
      this.model.familiaSolicitacao.filter(familia => {
        let peloMenos = false;

        // Filtrando os Exigidos da Familia
        var docsPf = exigiveis.filter(x =>
          mesmoCodigo(x.codGrupo, familia.codGrupo) &&
          mesmoCodigo(x.numFamilia, familia.numFamilia)
        )
        // Verificando se o documento esta cadastrado na tabela Qualifica Técnica
        docsPf.filter(dpf => {

          //Para cada exigido consulta se esta cadastrado
          var docExigivelCadastrado = qualificacoes.find(x =>
            mesmoCodigo(x.codDocumento, dpf.codDocumento)
          );

          if (!docExigivelCadastrado) {
            // Se não tiver cadastrado includo no erray de erros
            arrayErrosExigiveisFamilia = this.setArrayErrosExigiveis(arrayErrosExigiveisFamilia, familia);
            retorno = false;
          } else {
            // Se estiver cadastrado verifico se todos os campos estão preenchidos
            Object.keys(docExigivelCadastrado).forEach(prop => {
              docExigivelCadastrado = this.verificaDocNulo(docExigivelCadastrado, prop);

              if (this.verificaDocsExigiveisElegiveis(docExigivelCadastrado, prop)) {
                // Se não tiver  incluo no erray de erros
                if (arrayErrosExigiveisFamilia.indexOf(familia.familiaAssociada.descFamilia) === -1) {
                  arrayErrosExigiveisFamilia.push(familia.familiaAssociada.descFamilia);
                }

                retorno = false;
              }
            });
          }
        });

        // Filtrando os ***Elegiveis da Familia
         docsPf = elegiveis.filter(x =>
          mesmoCodigo(x.codGrupo, familia.codGrupo) &&
          mesmoCodigo(x.numFamilia, familia.numFamilia)
        );

        if (docsPf.length) {
          // Verificando se o documento esta cadastrado na tabela Qualifica Técnica
          docsPf.filter(dpf => {

            var docElegiveisCadastrado = qualificacoes.find(x =>
              mesmoCodigo(x.codDocumento, dpf.codDocumento)
            );

            if (docElegiveisCadastrado) {
              const possuiArquivo = (docElegiveisCadastrado.arquivoUpload &&
                docElegiveisCadastrado.arquivoUpload.toString().trim() !== "") ||
                (docElegiveisCadastrado.file && docElegiveisCadastrado.file.arquivoUpload);

              if (possuiArquivo) {
                peloMenos = true;
              }
            }
          });

          arrayErrosElegiveisFamilia = this.setArrayErrosElegiveis(arrayErrosElegiveisFamilia, peloMenos, familia);
        }

      })
      retorno = this.verificaErrosDocsFamilia(arrayErrosExigiveisFamilia, arrayErrosElegiveisFamilia, retorno);

      return retorno;
    },

    verificaFamilia(familiaAnterior, familiaAtual, peloMenos){
      if (familiaAnterior !== familiaAtual) {
        peloMenos = false;
      }
      return peloMenos;
    },

    //Verifica se possui algum Anexo Familia sem documento
    familiaExigeAnexo(codGrupo, numFamilia) {
      // Família 04.20 não exige anexo de CAT/atestado, assim como famílias de grupo >= 10
      return Number(codGrupo) < 10 && !(codGrupo === '04' && numFamilia === '20');
    },

    verificaFamiliaSemAnexo(){
      var familiasSemAnexo = this.model.familiaSolicitacao.filter(familia => {
        if (!this.familiaExigeAnexo(familia.codGrupo, familia.numFamilia)) {
          return false;
        }

        if (familia.anexoFamilia == null) {
          return true;
        }

        return familia.anexoFamilia.arquivoUpload == null;
      });
      return familiasSemAnexo.map( familia => {return `${familia.codGrupo}.${familia.numFamilia} - ${familia.familiaAssociada.descFamilia}`; });
    },

    verificaDocsExigiveisElegiveis(docCadastrado, prop){
      return (docCadastrado[prop] == null &&
        prop !== "arquivoUpload" &&
        prop !== "codControle" &&
        prop !== "numDocumento" &&
        prop !== "dtVencimento" &&
        prop !== "motivoRejeitado" &&
        prop !== "dtRejeicao" &&
        prop !== "qualificacaoTecnicaSituacao" &&
        prop !== "numDocumentoSEI" &&
        prop !== "idMotivoIndeferimentoArquivo" &&
        prop !== "idMotivoIndeferimentoArquivo2" &&
        prop !== "idMotivoIndeferimentoArquivo3" &&
        prop !== "dtRejeicao2" &&
        prop !== "dtRejeicao3" &&
        prop !== "motivoDeIndeferimento" &&
        prop !== "motivoDeIndeferimento2" &&
        prop !== "motivoDeIndeferimento3" &&
        prop !== "motivoIndeferimentoStr" &&
        prop !== "motivoIndeferimentoStr2" &&
        prop !== "motivoIndeferimentoStr3" &&
        prop !== "arquivoUpload02" &&
        prop !== "codControle02" &&
        prop !== "dtVencimento02" &&
        prop !== "dtRejeicao02" &&
        prop !== "numDocumentoSEI02" &&
        prop !== "idMotivoIndeferimentoArquivo02" &&
        prop !== "motivoDeIndeferimento02" &&
        prop !== "motivoIndeferimentoStr02");
    },

    verificaDocNulo(docCadastrado, prop){
      if (docCadastrado[prop] === "") {
        docCadastrado[prop] = null;
      }
      return docCadastrado;
    },

    // inclui no array de erros
    setArrayErrosElegiveis(arrayErrosElegiveisFamilia, peloMenos, familia) {
      if (!peloMenos) {
        // Se não tiver  incluo no erray de erros
        if (arrayErrosElegiveisFamilia.indexOf(familia.familiaAssociada.descFamilia) === -1) {
          arrayErrosElegiveisFamilia.push(familia.familiaAssociada.descFamilia);
        }
      }
      return arrayErrosElegiveisFamilia;
    },

    // inclui no array de erros
    setArrayErrosExigiveis(arrayErrosExigiveisFamilia, familia) {
      if (arrayErrosExigiveisFamilia.indexOf(familia.familiaAssociada.descFamilia) === -1) {
        arrayErrosExigiveisFamilia.push(familia.familiaAssociada.descFamilia);
      }
      return arrayErrosExigiveisFamilia;
    },

    verificaErrosDocsFamilia(arrayErrosExigiveisFamilia, arrayErrosElegiveisFamilia, retorno) {
      if (arrayErrosExigiveisFamilia.length) {
        this.setErro("Cadastre todos os documentos exigidos para as famílias <br><strong>" + arrayErrosExigiveisFamilia.join('<br>') + "</strong>", "tab-qualificacaoTecnica");
        retorno = false;
      }

      if (arrayErrosElegiveisFamilia.length) {
     
        this.setErro("Cadastre pelo menos um documento Elegível para as famílias <br><strong>"
          + arrayErrosElegiveisFamilia.join('<br>') + "</strong>", "tab-qualificacaoTecnica");
        retorno = false;
      }

      return retorno;
    },

    validModelQualificacao() {
      //valida tambem a regularidade fiscal
      let retorno = true;


      // flagEstrangeiro é um tipo string
      if (this.model.flagEstrangeiro === '1') {
        return true;
      }

      if (!this.validModelRegularidadeFiscal()) {
        retorno = false;
      } else {
        if (!this.$verificaPerfilHabilitador()) {
          retorno = this.verificaPreenchimentoRegFiscal(retorno);
        }
        if (!retorno) {
          return false;
        }

        this.grupoServico = this.model.familiaSolicitacao.find(x => x.codGrupo <= 9);
        this.grupoMaterial = this.model.familiaSolicitacao.find(x => x.codGrupo > 9);


        this.model.regularidadeFiscTrab.filter(item => {
          if (this.verificaObrigatoriedadeRegularidade(item.tipDocumento)) {
            Object.keys(item).forEach((chave) => {
              retorno = this.verificaDocsRegFiscal(item, retorno, chave);

            });
          }
        });
      }


      return retorno;
    },

    verificaPreenchimentoRegFiscal(retorno) {
      if (!this.model.regularidadeFiscTrab.length) {
        this.setErro("Preencha os dados de Regularidade Fiscal e Trabalhista", 'tab-regularidadeFiscal');
        this.hasErrorRegularidadeFiscal = true;
        retorno = false;
      }

      var dataAtual = new Date();
      dataAtual.setHours(0, 0, 0, 0);
      var DataInvalida = false;
      this.model.regularidadeFiscTrab.forEach(function(documento) {
          // Converter a string de dtVencimento para um objeto Date
          if(documento.dtVencimento != null){
          var dtVencimento = new Date(documento.dtVencimento);
          dtVencimento.setHours(0, 0, 0, 0);
          // Verificar se a dtVencimento é menor que a data atual
          if (dtVencimento < dataAtual) {      
            DataInvalida = true;        
          }
        }
      });

      if(DataInvalida){
          this.setErro("Existem datas de vencimento anterior a data atual em algum documento", 'tab-regularidadeFiscal');
          this.hasErrorRegularidadeFiscal = true;
          retorno = false;
      }
      // #157752-Verifica se tem algum documento preenchido com dados porém sem upload
      var listDocsPreechimentoIncompleto = this.model.regularidadeFiscTrab.filter( x=> (x.arquivoUpload == null
        && x.numDocumento) || (x.arquivoUpload == null && x.dtEmissao && x.dtAberturaEmpresa) ||
        (x.arquivoUpload == null && x.dtVencimento && x.dtAberturaEmpresa));

      if (listDocsPreechimentoIncompleto.length) {
         this.setErro("Preencha todos os dados de Regularidade Fiscal e Trabalhista", 'tab-regularidadeFiscal');
         this.hasErrorRegularidadeFiscal = true;
         retorno = false;
      }

      var valorRegModel = this.verificaRegularidadeModel();
      if (!valorRegModel)
      {
        //retorna falso
        this.setErro("Preencha os dados de Regularidade Fiscal e Trabalhista", 'tab-regularidadeFiscal');
        this.hasErrorRegularidadeFiscal = true;
        retorno = false;
      }
      return retorno;
    },

    verificaDocsCorrespondentes(chave){
      if (
        (!this.grupoMaterial && chave === "ContribuinteEstadualMaterial") ||
        ((!this.grupoServico || this.model.tipoCertificado === 3) && chave === "ContribuinteMunicipalServicos") ||
        (this.model.codUf === "BA" && chave === "EstadualBA") ||
        (this.model.codUf === "DF" && (chave === "Municipal" || chave === "ContribuinteMunicipalServicos")) ||
        (chave === "CNPJ")
      )
        return true;

      return false;
    },
    RetonaCECM(chave){
      return (chave === "ContribuinteEstadualMaterial" || chave === "ContribuinteMunicipalServicos")
    },

    // #151962 - Remocao de não obrigatoriedade dos documentos RegularidadeComFGTS e Trabalhista para o fornecedor PJ e MEI, agora é obritorio para todos os fornecedores.
    // verificaCNPJMEI(chave){
    //   return ((chave === "RegularidadeComFGTS" || chave === "Trabalhista") && this.model.tipFornecedor === 'J' 
    //   && this.model.categoria === "MEI")
    // },
    
    verificaDocsRegFiscal(item, retorno, chave){
      if (this.verificaDocsCorrespondentes(chave)) {
        return true;
      } else {
        var tipDocumento = this.enums.tipoDocumento.find(x=> x.valor === item.tipDocumento).chave;
        if (item[chave] == null &&
              (chave !== "codControle" &&
                chave !== "idRegularidadeFiscTrab" &&
                chave !== "arquivoUploadSituacao" &&
                chave !== "regularidadeFiscTrabSituacao" &&
                chave !== "motivoRejeitado" &&
                chave !== "dtRejeicao" &&
                chave !== "flagExclusao" &&
                chave !== "dtExclusao" &&
                chave !== "numDocumentoSEI" &&
                chave !== "idMotivoIndeferimentoArquivo" &&
                chave !== "motivoDeIndeferimento" &&
                chave !== "motivoIndeferimentoStr" &&
                chave !== "dtVencimento" &&
                chave !== "dtAberturaEmpresa"
              ) &&
              (tipDocumento === "ContribuinteEstadualMaterial" && this.$verificaPerfilHabilitador() && chave !== "dtEmissao") &&
              (item['arquivoUpload'] !== "Não Encontrado" || !this.isAlteracao)
        ) {
          this.setErro("Preencha os dados de Regularidade Fiscal e Trabalhista", 'tab-regularidadeFiscal');
          return false;
        }
      }
      return retorno;
    },

    //Verificar se existe a regularidade obrigatoria no modelo preenchida
    verificaRegularidadeModel() {
      let retorno = true
      this.grupoServico = this.model.familiaSolicitacao.find(x => x.codGrupo <= 9);
      this.grupoMaterial = this.model.familiaSolicitacao.find(x => x.codGrupo > 9);

      this.enums.tipoDocumento.filter(item => {
        var chave = item.chave;

        if (!(
              (!this.grupoMaterial && chave === "ContribuinteEstadualMaterial") ||
              ((!this.grupoServico || this.model.tipoCertificado === 3) && chave === "ContribuinteMunicipalServicos") ||
              (this.model.codUf === "BA" && chave === "EstadualBA" && this.model.flagEstrangeiro !== '1') ||
              (this.model.codUf === "DF" &&
              (chave === "Municipal" || chave === "ContribuinteMunicipalServicos") && this.model.flagEstrangeiro !== '1') || // flagEstrangeiro é um tipo string
              (chave === "RegularidadeComFGTS" && this.model.tipFornecedor === 'F') ||
              (chave === "CNPJ" && this.model.tipFornecedor === 'F' ) ||
              (chave === "Municipal" && this.model.tipFornecedor === 'F' && this.model.tipoCertificado === 3)
            )) 
        {
          var regularidadeFiscTrab = this.model.regularidadeFiscTrab.find(
              x => x.tipDocumento === item.valor
          );

          //Se não achar a regularidade no modelo
          if (regularidadeFiscTrab && retorno) {
            retorno = true;
          }
          else if (chave === "ContribuinteEstadualMaterial") {
            retorno = true;
          }
          else if ((chave === "ContribuinteMunicipalServicos") && (this.model.categoria === 'MEI'))  {
            retorno = true;
          }
          else {
            retorno = false;
          }
        }
      });

      return retorno;
    },
   
    verificaObrigatoriedadeRegularidade(tipDocumento) {
      if (this.model.flagEstrangeiro === '1') {
        return false;
      }
      var tipoObj = this.enums.tipoDocumento.find(x => x.valor === tipDocumento);
      if (!tipoObj) return false;
      var chave = tipoObj.chave;
     
      if (
        chave === "ContribuinteEstadualMaterial" ||
        (chave === "ContribuinteMunicipalServicos" && (this.model.categoria === 'MEI' || this.model.tipoCertificado === 3)) ||
        (this.model.codUf === "BA" && chave === "EstadualBA" && this.model.flagEstrangeiro !== '1') || // flagEstrangeiro é um tipo string
        (this.model.codUf === "DF" && (chave === "Municipal" || chave === "ContribuinteMunicipalServicos") && this.model.flagEstrangeiro !== '1') ||
        (this.model.tipFornecedor === "J" && chave === "CNPJ") ||
        (this.model.tipFornecedor === "F" && (chave === "CNPJ" || chave === "RegularidadeComFGTS"))
        ) {
        return false;
      }
      return true;
    },

    validModelFormulariosDeclaracoes() {
      //valida tambem a qualificacao economica
      let retorno = true;
      let msgErro = "Preencha os dados de Qualificação Econômico Financeira."

      if (!this.validModelQualificacao()) {
        return false;
      } else {
        if (this.model.tipoCertificado === 1) {
          retorno = this.verificaDocsPj(retorno, msgErro);
        }
      }

      return retorno;
    },

    // verifica se os docs de regularidade fiscal de PJ foram preenchidos corretamente
    verificaDocsPj(retorno, msgErro) {
      if (this.model.tipFornecedor === "J") {
        if (!this.model.concordataFalencia) {
          return false;
        } else {
          retorno = this.verificaConcordata(msgErro);
          if (!retorno) {
            return false;
          }
        }

        retorno = this.verificaBalanco(retorno, msgErro);

      } else {
        retorno = this.verificaConcordata(msgErro);
      }

      return retorno;
    },

    verificaBalanco(retorno, msgErro) {
      if (!this.model.balancoFinanceiro) {
        return false;
      } else {
        var balancoFinanceiro = Object.assign({}, this.model.balancoFinanceiro);

        delete balancoFinanceiro.arquivoUploadSituacao;
        delete balancoFinanceiro.motivoRejeitado;
        delete balancoFinanceiro.dtRejeicao;
        delete balancoFinanceiro.numDocumentoSEI;

        delete balancoFinanceiro.arquivoUploadSituacao02;
        delete balancoFinanceiro.motivoRejeitado02;
        delete balancoFinanceiro.dtRejeicao02;
        delete balancoFinanceiro.numDocumentoSEI02;

        Object.keys(balancoFinanceiro).forEach((chave) => {
          retorno = this.verificaItensBalanco(chave, retorno);
        });

        if (!retorno) {
          this.setErro(msgErro, 'tab-qualificacao');
          return false;
        }

        if (this.totaisContas.ativoTotal !== this.totaisContas.passivoTotal) {
          msgErro = "O Ativo Total não pode ser diferente do Passivo Total.";
          this.setErro(msgErro, 'tab-qualificacao');
          return false;
        }
      }
      return retorno;
    },
    verificaItensBalanco(chave, retorno) {
      if (chave !== "idMotivoIndeferimentoArquivo" &&
        chave !== "idMotivoIndeferimentoArquivo2" &&
        chave !== "idMotivoIndeferimentoArquivo3" &&
        chave !== "idMotivoIndeferimentoArquivo02" &&
        chave !== "idMotivoIndeferimentoArquivo02_2" &&
        chave !== "idMotivoIndeferimentoArquivo02_3" &&
        chave !== "idMotivoIndeferimentoArquivo03" &&
        chave !== "motivoDeIndeferimento" &&
        chave !== "motivoIndeferimentoStr" &&
        chave !== "dtValidadeBalanco" &&
        chave !== "numLivroDiario02" &&
        chave !== "dtBalanco02" &&
        chave !== "arquivoUpload02" &&
        chave !== "motivoDeIndeferimento02" &&
        chave !== "motivoIndeferimentoStr02" &&
        chave !== "ativoCirculante02" &&
        chave !== "realizavelLP02" &&
        chave !== "investimento02" &&
        chave !== "imobilizado02" &&
        chave !== "intangivel02" &&
        chave !== "passivoCirculante02" &&
        chave !== "exigivelLP02" &&
        chave !== "resultExerciciosFut02" &&
        chave !== "patrimonioLiquido02" &&
        chave !== "capitalSocial02" &&
        chave !== "receitaOpeLiquido02" &&
        chave !== "receitaOpeBruto02" &&
        chave !== "liquidezCorrente02" &&
        chave !== "produtividade02" &&
        chave !== "imobilizacaoCapitalProprio02" &&
        chave !== "dtValidadeBalanco02" &&
        chave !== "anoBalanco2" &&
        chave !== "fornecedorSolicitacao" &&
        chave !== "identificador_balanco"  // evita que a data de validade do balanco seja obrigatorio

      ) {
        if (this.model.balancoFinanceiro[chave] === "") {
          this.model.balancoFinanceiro[chave] = null;
        }

        if ((this.model.balancoFinanceiro[chave] == null)
          && (this.model.balancoFinanceiro['arquivoUpload'] !== "Não Encontrado" || !this.isAlteracao)) {
          console.warn("verificaItensBalanco failed due to null at chave:", chave);
          retorno = false
        }

        if ((this.model.balancoFinanceiro[chave] === "Não Encontrado")) {
          console.warn("verificaItensBalanco failed due to Não Encontrado at chave:", chave);
          retorno = false;
        }
      }

      return retorno;
    },

    // verifica se a concordata é válida
    verificaConcordata(msgErro) {
      if (!this.validaConcordata()) {

        this.setErro(msgErro, 'tab-qualificacao');
        return false
      }
      return true;
    },

    // valida os itens de concordata
    validaConcordata() {//Declaracao de variaveis
      //valida a concordata
      let retorno = true;

      var concordataFalencia = Object.assign({}, this.model.concordataFalencia);

      delete concordataFalencia.arquivoUploadSituacao;
      delete concordataFalencia.motivoRejeitado;
      delete concordataFalencia.dtRejeicao;
      delete concordataFalencia.codControle;
      delete concordataFalencia.numDocumentoSEI;

      Object.keys(concordataFalencia).forEach((chave) => {

        if (chave !== "idMotivoIndeferimentoArquivo" &&
          chave !== "idMotivoIndeferimentoArquivo2" &&
          chave !== "idMotivoIndeferimentoArquivo3" &&
          chave !== "idMotivoIndeferimentoArquivo02" &&
          chave !== "idMotivoIndeferimentoArquivo02_2" &&
          chave !== "idMotivoIndeferimentoArquivo02_3" &&
          chave !== "idMotivoIndeferimentoArquivo03" &&
          chave !== "motivoDeIndeferimento" &&
          chave !== "motivoIndeferimentoStr" &&
          chave !== "fornecedorSolicitacao"
        ) {
          if (this.model.concordataFalencia[chave] === "") {
            this.model.concordataFalencia[chave] = null;
          }
          if ((this.model.concordataFalencia[chave] == null)
            && (this.model.concordataFalencia['arquivoUpload'] !== "Não Encontrado" || !this.isAlteracao)) {
            console.warn("validaConcordata failed due to null at chave:", chave);
            retorno = false
          }

          if ((this.model.concordataFalencia[chave] === "Não Encontrado")) {
            console.warn("validaConcordata failed due to Não Encontrado at chave:", chave);
            retorno = false;
          }
        }
      })

      return retorno;
    },

    setErro(msg, abaErro) {
      this.erros.erro = true;
      this.erros.msg = msg;
      this.erros.abaErro = abaErro;
      document.scrollingElement.scrollTop = 0;
    },

    _validaModel(_desObriga) {
      //valida a desobrigacao de campos
      let retorno = true;
      let obj = JSON.parse(JSON.stringify(this.model))
      let desObriga = _desObriga ?
        JSON.parse(JSON.stringify(this.desObrigaGeral)).concat(_desObriga) :
        JSON.parse(JSON.stringify(this.desObriga));

      desObriga.forEach((item) => {
        delete obj[item];
      })

      Object.keys(obj).forEach((chave) => {

        if (this.model[chave] == null) {

          console.warn("required-field-not-found: " + chave);
          retorno = false;
        }
      });
      return retorno;

    },
  }
}
